// Mirrors lookup table IDs in the database (R__001_init_lookup_data.sql and migrations).
// Keep in sync with lib/src/Constants.cs on the API side.

export const SecurityRole = {
  VIEWER:     10,
  EDITOR:     20,
  /** Scoped to one team: its members, its folders, its templates. */
  TEAM_ADMIN: 50,
  /** Site-wide: every team, every user, every tenant's logs and API keys. */
  SUPER_ADMIN: 1000,
} as const

/** Display names for SecurityRole. Labels only: never iterate this to offer roles (Super Admin is not assignable). */
export const ROLE_LABELS: Record<number, string> = {
  [SecurityRole.VIEWER]:      'Viewer',
  [SecurityRole.EDITOR]:      'Editor',
  [SecurityRole.TEAM_ADMIN]:  'Team Admin',
  [SecurityRole.SUPER_ADMIN]: 'Super Admin',
}

export const UserStatus = {
  INVITED: 5,
  ACTIVE:  10,
} as const

/** Folder permission actions (permission_action_lookup). MAX-wins over folder-ancestor grants. */
export const PermissionAction = {
  VIEW:   10,
  RENDER: 20,
  EDIT:   30,
  MANAGE: 40,
} as const

export const TemplateStatus = {
  DRAFT:    10,
  ACTIVE:   20,
  ARCHIVED: 30,
  DELETED:  40,
} as const

export const VariableKind = {
  SCALAR:      10,
  LOOP:        20,
  CONDITIONAL: 30,
} as const

export const RenderJobStatus = {
  PENDING:    10,
  PROCESSING: 20,
  COMPLETE:   30,
  FAILED:     40,
} as const
